module.exports = __webpack_public_path__ + "static/img/function1.acbe471.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon/function1.svg
// module id = vBiu
// module chunks = 11